import React, { Component } from 'react';
import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import {isEmpty} from 'lodash'
import IntlMessages from 'util/IntlMessages';
function mapStateToProps({accountsData}) {
    const { AvtalTyp,currentAccount } = accountsData;
    return {
        AvtalTyp,currentAccount
    };
}

class Leverantör extends Component {
    state={
        avtaltype:"",
        Leverantorlist:"",
        Leverantor:isEmpty(this.props.valueLeverator)?"":this.props.valueLeverator
    }
    sortByProperty(property){  
        return function(a,b){  
           if(a[property] > b[property])  
              return 1;  
           else if(a[property] < b[property])  
              return -1;  
       
           return 0;  
        }  
     }
    componentDidUpdate =()=>{
        const avtaltype = this.props.avtalType
        let LevList = [];
        if(!isEmpty(avtaltype) && this.props.avtalType !== this.state.avtaltype)
        {
            let LevLists = (this.props.AvtalTyp.filter((avtTyp)=>{
                if(avtTyp.type === avtaltype){
                    return avtTyp
                }
            }))
            this.setState({
                Leverantorlist:"",
                Leverantor:"Välj"
            })
            if(!isEmpty(LevLists[0].Operator)){
                LevList = LevLists[0].Operator
                if(!LevList.some(item=>{return item.operator === "Välj"})){
                    LevList.push({id:0,operator:"Välj"});
                }
                LevList.sort(this.sortByProperty('id'));                
            }
            let HasLeve= isEmpty(this.props.AvtalTyp)?"":this.props.AvtalTyp.filter(item=>{
                return item.type === avtaltype
            })[0].defaultOperator
            let OpValue = isEmpty(LevList)?"":LevList.filter(item=>{return item.id === HasLeve})


        this.setState({
            Leverantorlist:LevList,
            avtaltype:this.props.avtalType,
            Leverantor:isEmpty(LevList)?"":isEmpty(OpValue)?"":OpValue[0].operator
        })
        this.props.getAVtalLeverator(isEmpty(LevList)?"":isEmpty(OpValue)?"":OpValue[0].operator)
        }     
        
    }
    getLeverantor=(e)=>{
        this.setState({
            Leverantor:e.target.value
        })
        this.props.getAVtalLeverator(e.target.value)
    }
    render() {
        return (
            <div>
                <form>
                <div style={{ height: '64px', paddingTop: '15px' }}>
                <TextField
                    select={isEmpty(this.state.Leverantorlist)?false:true}
                    label={<IntlMessages id="Supplier"/>}
                    variant="outlined"
                    size="small"
                    value={this.state.Leverantor}
                    fullWidth
                    onChange={this.getLeverantor}
                    SelectProps={{
                        native: isEmpty(this.state.Leverantorlist)?false:true,
                    }}
                >
                    {
                       
                    isEmpty(this.state.Leverantorlist)?"":
                    
                        this.state.Leverantorlist.map((option) => (
                        <option key={option.id} value={option.operator}>
                            {option.operator}
                        </option>
                    ))
                    
                }
                </TextField>
            </div>
        </form>
            </div>
        );
    } 
}

export default connect(
    mapStateToProps
)(Leverantör);
